import { createFileRoute } from '@tanstack/react-router';
import { FinancePage } from '../../features/finance/FinancePage.jsx';

export const Route = createFileRoute('/_app/finance')({ component: FinancePage });
